import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import {TrafficManagementClientBase} from './TrafficManagementClientBase';
import {throwException, isAxiosError} from './TrafficManagementClientBase';

export class InvoiceClient extends TrafficManagementClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: MNSwagClientConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    get(invoiceId: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Invoice/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getAll(requestId: string, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Invoice/GetAll/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getTracker( cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Invoice/GetTracker";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTracker(_response);
        });
    }

    protected processGetTracker(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Created
     */
    create(body: CreateInvoiceRequest | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = resultData201 !== undefined ? resultData201 : null as any;

            return Promise.resolve<any>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: UpdateInvoiceRequest | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class CreateInvoiceRequest implements ICreateInvoiceRequest {
    parentId?: string;
    applicationSent?: boolean;
    poNumber?: string | undefined;
    workStart?: Date;
    workEnd?: Date;
    charge?: number;
    invoiceNumber?: string | undefined;
    invoiced?: boolean;
    councilId?: number;
    feeType?: number;
    notes?: string | undefined;

    constructor(data?: ICreateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.applicationSent = _data["applicationSent"];
            this.poNumber = _data["poNumber"];
            this.workStart = _data["workStart"] ? new Date(_data["workStart"].toString()) : undefined as any;
            this.workEnd = _data["workEnd"] ? new Date(_data["workEnd"].toString()) : undefined as any;
            this.charge = _data["charge"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiced = _data["invoiced"];
            this.councilId = _data["councilId"];
            this.feeType = _data["feeType"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["applicationSent"] = this.applicationSent;
        data["poNumber"] = this.poNumber;
        data["workStart"] = this.workStart ? this.workStart.toISOString() : undefined as any;
        data["workEnd"] = this.workEnd ? this.workEnd.toISOString() : undefined as any;
        data["charge"] = this.charge;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiced"] = this.invoiced;
        data["councilId"] = this.councilId;
        data["feeType"] = this.feeType;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateInvoiceRequest {
    parentId?: string;
    applicationSent?: boolean;
    poNumber?: string | undefined;
    workStart?: Date;
    workEnd?: Date;
    charge?: number;
    invoiceNumber?: string | undefined;
    invoiced?: boolean;
    councilId?: number;
    feeType?: number;
    notes?: string | undefined;
}

export class UpdateInvoiceRequest implements IUpdateInvoiceRequest {
    id?: number;
    parentId?: string;
    applicationSent?: boolean;
    poNumber?: string | undefined;
    workStart?: Date;
    workEnd?: Date;
    charge?: number;
    invoiceNumber?: string | undefined;
    invoiced?: boolean;
    councilId?: number;
    feeType?: number;
    notes?: string | undefined;

    constructor(data?: IUpdateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.applicationSent = _data["applicationSent"];
            this.poNumber = _data["poNumber"];
            this.workStart = _data["workStart"] ? new Date(_data["workStart"].toString()) : undefined as any;
            this.workEnd = _data["workEnd"] ? new Date(_data["workEnd"].toString()) : undefined as any;
            this.charge = _data["charge"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiced = _data["invoiced"];
            this.councilId = _data["councilId"];
            this.feeType = _data["feeType"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["applicationSent"] = this.applicationSent;
        data["poNumber"] = this.poNumber;
        data["workStart"] = this.workStart ? this.workStart.toISOString() : undefined as any;
        data["workEnd"] = this.workEnd ? this.workEnd.toISOString() : undefined as any;
        data["charge"] = this.charge;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiced"] = this.invoiced;
        data["councilId"] = this.councilId;
        data["feeType"] = this.feeType;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateInvoiceRequest {
    id?: number;
    parentId?: string;
    applicationSent?: boolean;
    poNumber?: string | undefined;
    workStart?: Date;
    workEnd?: Date;
    charge?: number;
    invoiceNumber?: string | undefined;
    invoiced?: boolean;
    councilId?: number;
    feeType?: number;
    notes?: string | undefined;
}